import { CheckCircle, ArrowRight } from "lucide-react";

export const ZeroTrustDmarcTakeaway = () => {
  return (
    <div className="relative overflow-hidden bg-gradient-to-r from-destructive/5 via-destructive/10 to-destructive/5 border border-destructive/20 rounded-2xl p-5 sm:p-6">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-96 h-24 bg-destructive/10 blur-3xl" />
      
      <div className="relative flex items-start gap-4">
        <div className="shrink-0 w-10 h-10 sm:w-12 sm:h-12 rounded-xl bg-destructive/15 flex items-center justify-center">
          <CheckCircle className="w-5 h-5 sm:w-6 sm:h-6 text-destructive" />
        </div>
        <div className="flex-1">
          <h2 className="font-display text-lg sm:text-xl font-semibold text-foreground mb-2">
            Critical Update for 2026
          </h2>
          <p className="text-sm sm:text-base text-muted-foreground leading-relaxed">
            Google and Yahoo now require <span className="font-semibold text-foreground">strict DMARC alignment with p=reject</span> for all senders. 
            Relaxed policies (p=none, p=quarantine) no longer meet requirements. 
            Organizations without proper DMARC enforcement will see emails rejected outright—not just spam-filtered.
          </p>
          <div className="flex items-center gap-2 mt-3 text-sm text-destructive font-medium">
            <ArrowRight className="w-4 h-4" />
            <span>See the implementation checklist below</span>
          </div>
        </div>
      </div>
    </div>
  );
};